module.exports = __webpack_public_path__ + "img/6.5325ea9a.png";